<template>
  <div class="checkFormBox">
    <div class="checkFormBox_title">{{title}}</div>
    <div class="checkFormBox_main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.checkFormBox {
  max-width: 867px;
  margin: 0 auto;
  margin-top: 24px;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  overflow: hidden;
}
.checkFormBox_title {
  background: #5ba7ad;
  text-align: center;
  color: #fff;
  font-size: 18px;
  line-height: 25px;
  padding: 8px;
}
.checkFormBox_main {
  max-width: 819px;
  margin: auto;
  font-size: 16px;
  line-height: 22px;
  padding: 24px;
}
</style>

<style>
.form_label {
  font-size: 16px;
  font-weight: 500;
  color: #5ba7ad;
  line-height: 22px;
  margin-bottom: 11px;
}
.form_value {
  font-size: 16px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
  line-height: 22px;
  margin-bottom: 24px;
  min-height: 22px;
}
</style>